import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyB1bgDZvluhVCkQ8TN7HlgfkeoNwpUlqJg",
//   authDomain: "catering-user-webapplication.firebaseapp.com",
//   projectId: "catering-user-webapplication",
//   storageBucket: "catering-user-webapplication.appspot.com",
//   messagingSenderId: "614883073124",
//   appId: "1:614883073124:web:a185818b3cbd6d428c9371",
//   measurementId: "G-DT1TTLGTB0"
// };
  const firebaseConfig = {
  apiKey: "AIzaSyBt1hljgLvYvlFgYyhccoF8SNENhczaiCo",
  authDomain: "public-transport-d6788.firebaseapp.com",
  projectId: "public-transport-d6788",
  storageBucket: "public-transport-d6788.appspot.com",
  messagingSenderId: "500024395973",
  appId: "1:500024395973:web:d84cfb669d43816fdf08ac",
  measurementId: "G-JY9JRPD2M3"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

// Initialize Firestore and Storage
const db = getFirestore(app);
const storage = getStorage(app);

export { app, analytics, db, storage };

